import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah9m9jp14a1h3mr6gcg";

type Status = "idle" | "loading" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const honeypot = String(formData.get("website_alt") ?? "").trim();

    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功！我们会把精选快讯发送到你的邮箱。");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      if (typeof value === "string" && value.trim() !== "") {
        payload.append(key, value);
      }
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        meta?: { message?: string; detail?: string };
        message?: string;
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam =
        typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！我们会把精选快讯发送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          serverMsg && !isSpam && typeof serverMsg === "string"
            ? serverMsg
            : "提交失败，请稍后再试。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <form
      id="subscribe-newsletter"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full max-w-xl"
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="你的邮箱地址"
            className="w-full pl-10 pr-3 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors font-label"
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "免费订阅"}
        </button>
      </div>

      <div className="form-honeypot-guard" aria-hidden="true">
        <label htmlFor="website_alt">请勿填写此栏</label>
        <input
          id="website_alt"
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
      </div>

      {status === "success" && message && (
        <p className="mt-3 text-sm text-secondary-700 font-label flex items-center gap-1.5">
          <i className="ri-checkbox-circle-line"></i>
          {message}
        </p>
      )}
      {status === "error" && message && (
        <p className="mt-3 text-sm text-primary-600 font-label flex items-center gap-1.5">
          <i className="ri-error-warning-line"></i>
          {message}
        </p>
      )}
      {status === "idle" && (
        <p className="mt-3 text-xs text-foreground-500 font-label">
          每周发送 1-2 次，只保留最值得看的几条，随时可退订。
        </p>
      )}
    </form>
  );
}